export default __webpack_public_path__ + "static/media/agendaEvent.aa3e94b1.png";